import { render, staticRenderFns } from "./userinfo.vue?vue&type=template&id=f13a2a5e&scoped=true&"
import script from "./userinfo.vue?vue&type=script&lang=js&"
export * from "./userinfo.vue?vue&type=script&lang=js&"
import style0 from "./userinfo.vue?vue&type=style&index=0&id=f13a2a5e&lang=scss&scoped=true&"
import style1 from "./userinfo.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f13a2a5e",
  null
  
)

export default component.exports